import React from 'react';
import {QuestionTypeViewPropTypes} from '../../../shapes/index.mjs';
import classNames from 'classnames';
import NumberInput from '@ignitesales/react-number-format';
import QuestionText from '../../questions/QuestionText.jsx';
import {useIntl} from 'react-intl';
import {getMessageValue} from '../../../i18n/messageUtil';
import {useText} from '../../TextContext';

const Number = props => {
  const {className, valueChanged, question, value: {value} = {}} = props;

  const intl = useIntl();
  const textContext = useText();

  const classes = classNames(className, {
    'number-format': true,
  });

  const placeholder = getMessageValue(intl.locale, `${question.appkey}.input.placeholder`);

  return (
    <section className={classes}>
      <QuestionText question={question} />
      <NumberInput
        onChange={valueChanged}
        plus={<i className="fa fa-plus" />}
        minus={<i className="fa fa-minus" />}
        step={question?.attributes?.step || 1}
        value={value}
        min={question?.attributes?.min || 0}
        max={question?.attributes?.max || 10000000}
        format={question?.attributes?.format || 'number'}
        pad={
          <span>
            <i className="fa fa-calculator" />
          </span>
        }
        padElementId="root"
        header={textContext?.[`${question.appkey}`] || intl.formatMessage({id: question.appkey})}
        placeholder={placeholder}
        decimalScale={question?.attributes?.decimalScale || 0}
      />
    </section>
  );
};

Number.propTypes = QuestionTypeViewPropTypes;

export default Number;
